import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';

import { NavigationService } from 'core/navigation.service';
import { isNilOrEmpty } from 'helpers';

@Component({
  selector: 'app-entity-back-button',
  templateUrl: './entity-back-button.component.html',
  styleUrls: ['./entity-back-button.component.scss']
})
export class EntityBackButtonComponent implements OnChanges {
  @Input() entityId: string;
  @Input() campaignId: string;

  constructor(
    private _navigationService: NavigationService,
    private _router: Router
  ) { }

  ngOnChanges(_changes: SimpleChanges): void {
    this._getBackLocation();
  }

  goBackClicked() {
    const backLocation = this._getBackLocation();

    // No location, default is to go to wall chart.
    if (isNilOrEmpty(backLocation)) {
      return this._router.navigateByUrl(`/entity/list?campaignId=${this.campaignId}`);
    }

    return this._navigationService.goBackTo(backLocation);
  }

  private _getBackLocation() {
    // Reverse the history so most recent navigations are first...
    // Then filter out URLs not related to this campaignId
    const reversedHistory = this._navigationService.getHistory()
      .map(url => url)
      .filter(url => url.includes(`campaignId=${this.campaignId}`))
      .reverse();

    // Next, remove all the visits within the current profile page.
    const nonProfileLinks = reversedHistory.filter(url => !url.includes(`/entity/view/${this.entityId}`));

    // The first item in the array will be the most recent page visited
    // which is not in the current entity profile page.
    // i.e. clicking back while on the notes tab, will not go back to the main profile tab.
    return nonProfileLinks[0];
  }
}
